var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-cancel-button"},[_c('button',{staticClass:"cancel-button",attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('span',{staticClass:"cancel-button-text"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }